/**
 * Fixed, closed set of time units for transformation/node durations
 * (segons/minuts/hores/dies/setmanes/mesos) — same "plain enum, fixed
 * frontend list" shape as tags/tagColors.ts's TAG_COLORS, not the dynamic,
 * user-editable UnitDef/unit_conversions catalog used for ingredient
 * quantities. The wire format (API + domain) is always a plain number of
 * seconds — `seconds` here is only a frontend conversion factor, used by
 * the editor (amount+unit -> seconds) and the display formatters in
 * textFormatting.ts (seconds -> composite "3 dies i 2 hores" text).
 */

export interface TimeUnitDef {
  key: string;
  singular: string;
  plural: string;
  /** Short form for the clock-badge display (durationBadgeHtml in
   * textFormatting.ts) — no singular/plural distinction needed there. */
  abbreviation: string;
  seconds: number;
}

export const TIME_UNITS: TimeUnitDef[] = [
  { key: 'seconds', singular: 'segon', plural: 'segons', abbreviation: 'seg.', seconds: 1 },
  { key: 'minutes', singular: 'minut', plural: 'minuts', abbreviation: 'min.', seconds: 60 },
  { key: 'hours', singular: 'hora', plural: 'hores', abbreviation: 'h.', seconds: 3600 },
  { key: 'days', singular: 'dia', plural: 'dies', abbreviation: 'dies', seconds: 86400 },
  { key: 'weeks', singular: 'setmana', plural: 'setmanes', abbreviation: 'set.', seconds: 604800 },
  { key: 'months', singular: 'mes', plural: 'mesos', abbreviation: 'mesos', seconds: 2592000 }, // approx, 30-day month
];

export function getTimeUnit(key: string): TimeUnitDef | undefined {
  return TIME_UNITS.find(u => u.key === key);
}
